import type React from 'react'
import type { JSX } from 'react'
import type { LAYOUT } from 'vars/index'

import { COLOR, FIXED_INDENTS } from 'vars/index'
import { SkeletonSC } from './Skeleton.styled'

export interface ISkeletonProps {
  children?: React.ReactNode
  horizontalLayoutOffsets?: LAYOUT | FIXED_INDENTS
  componentsBackgroundColor?: COLOR
  height?: string
  minHeight?: string
  margins?: FIXED_INDENTS[]
  pageBackgroundColor?: COLOR
}

export const Skeleton = ({
  children,
  horizontalLayoutOffsets = FIXED_INDENTS.INDENT_0,
  componentsBackgroundColor = COLOR.TEXT_ICON_CONSTANT_DARK,
  height,
  minHeight,
  margins,
  pageBackgroundColor,
}: ISkeletonProps): JSX.Element => {
  return (
    <SkeletonSC
      horizontalLayoutOffsets={horizontalLayoutOffsets}
      componentsBackgroundColor={componentsBackgroundColor}
      height={height}
      pageBackgroundColor={pageBackgroundColor}
      minHeight={minHeight}
      margins={margins}
    >
      {children}
    </SkeletonSC>
  )
}
